import documentApi from "@/service/document";

// Resolve HTTP lazily to avoid a circular import with the store.
let HTTP;
function http() {
  if (!HTTP) {
    // eslint-disable-next-line global-require
    const mod = require("@/service/axios");
    HTTP = mod.HTTP;
  }
  return HTTP;
}

const initState = () => ({
  documentList: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
  filters: {
    status: "",
  },
  searchKeyword: "",
  viewMode: "grid", // 'grid' | 'list'
});

const getters = {
  documentList: (state) => state.documentList,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination,
  filters: (state) => state.filters,
  searchKeyword: (state) => state.searchKeyword,
  viewMode: (state) => state.viewMode,
  isEmpty: (state) =>
    !state.loading && state.documentList.length === 0,
};

const mutations = {
  SET_LIST(state, list) {
    state.documentList = Array.isArray(list) ? list : [];
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_ERROR(state, value) {
    state.error = value;
  },
  SET_PAGINATION(state, payload) {
    state.pagination = { ...state.pagination, ...payload };
  },
  SET_FILTER(state, { key, value }) {
    state.filters = { ...state.filters, [key]: value };
  },
  SET_SEARCH(state, value) {
    state.searchKeyword = value;
  },
  SET_VIEW_MODE(state, value) {
    state.viewMode = value;
  },
  RESET(state) {
    Object.assign(state, initState());
  },
};

const actions = {
  async fetchList({ commit, state, rootState }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      http().defaults.headers.common.Authorization = `Bearer ${rootState.token}`;
      const params = {
        search: state.searchKeyword,
        status: state.filters.status,
        page: state.pagination.page,
        limit: state.pagination.limit,
      };
      const res = await documentApi.fetchList(params);
      if (res.success) {
        const data = res.obj || res.data || [];
        commit("SET_LIST", Array.isArray(data) ? data : data.list || []);
        if (typeof res.total === "number") {
          commit("SET_PAGINATION", { total: res.total });
        } else if (data.total != null) {
          commit("SET_PAGINATION", { total: data.total });
        }
      } else {
        commit("SET_LIST", []);
        commit("SET_PAGINATION", { total: 0 });
      }
    } catch (e) {
      console.error("document/fetchList", e);
      commit("SET_ERROR", e);
      commit("SET_LIST", []);
      commit("SET_PAGINATION", { total: 0 });
    } finally {
      commit("SET_LOADING", false);
    }
  },
  setSearchKeyword({ commit, dispatch }, value) {
    commit("SET_SEARCH", value);
    commit("SET_PAGINATION", { page: 1 });
    dispatch("fetchList");
  },
  setStatusFilter({ commit, dispatch }, value) {
    commit("SET_FILTER", { key: "status", value });
    commit("SET_PAGINATION", { page: 1 });
    dispatch("fetchList");
  },
  setPage({ commit, dispatch }, page) {
    commit("SET_PAGINATION", { page });
    dispatch("fetchList");
  },
  setLimit({ commit, dispatch }, limit) {
    commit("SET_PAGINATION", { page: 1, limit });
    dispatch("fetchList");
  },
  setViewMode({ commit }, value) {
    commit("SET_VIEW_MODE", value);
  },
  async create({ dispatch }, payload) {
    const res = await documentApi.create(payload);
    if (res && res.success) dispatch("fetchList");
    return res;
  },
  async update({ dispatch }, { id, payload }) {
    const res = await documentApi.update(id, payload);
    if (res && res.success) dispatch("fetchList");
    return res;
  },
  async remove({ dispatch }, id) {
    const res = await documentApi.remove(id);
    if (res && res.success) dispatch("fetchList");
    return res;
  },
};

export default {
  namespaced: true,
  state: initState(),
  getters,
  mutations,
  actions,
};
